import axios from '@/plugins/axios';
import type { ElegibilidadeDaPesquisa, SalvarPesquisaPayload } from '@/types/pesquisa-satisfacao.types';

const API_PESQUISA = '/api/pesquisa/satisfacao';

export const PesquisaSatisfacaoService = {
  async salvar(payload: SalvarPesquisaPayload): Promise<string> {
    const resposta = await axios.post(API_PESQUISA, payload);
    return resposta.data?.mensagem ?? 'Obrigado por avaliar o C-Conecte!';
  },

  async adiar(): Promise<void> {
    await axios.post(`${API_PESQUISA}/adiamento`);
  },

  async verificarElegibilidade(): Promise<ElegibilidadeDaPesquisa> {
    const resposta = await axios.get<ElegibilidadeDaPesquisa>(`${API_PESQUISA}/elegibilidade`);
    return resposta.data;
  },
};
